import React, { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { apiGet } from 'tennders-stracture/libs/api'
import { FINANCE_MODULE_COST_INVOICE } from 'tennders-stracture/libs/permissions'
import Attachment from 'tennders-market/common/components/element/Attachment'
import { withPermissionControl } from 'tennders-auth/hocs/withPermissionControl'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import useMultipleCostInvoiceModal from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoiceModal'
import GHref from 'tennders-market/common/components/element/GHref'
import { dateToStr } from 'tennders-stracture/libs/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

type Props = {
  transaction: TransactionType
}

const AddCostInvoiceButton = ({ transaction } : Props) => {
  const { t } = useTranslation()
  const [costInvoices, setCostInvoices] = useState([])

  const defaultForm = {
    transaction: transaction.id,
    isSpanishCompany: transaction.bookedCompany?.country === 'ES' ? 1 : 0,
    vat: transaction.matchedTruck?.company?.country === 'ES' ? 21 : 0,
    irpf: 0,
    vatAmount: 0,
    dateOfIssue: new Date()
  }
  const [initialForm, setInitialForm] = useState({ ...defaultForm })

  const { modal, show } = useMultipleCostInvoiceModal({
    refresh: () => fetchCostInvoices(),
    selectedTransaction: transaction,
    initialForm,
    isQC: false
  })

  const fetchCostInvoices = async () => {
    try {
      const data = await apiGet(`/costInvoice/byTransaction/${transaction.id}`, { date: new Date() })
      setCostInvoices(data || [])
    } catch (e) {
      // do nothing
    }
  }

  useEffect(() => {
    if (transaction) {
      if (transaction.hasCostInvoice) {
        fetchCostInvoices()
      }
    }
    return () => (setCostInvoices([]))
  }, [transaction?.hasCostInvoice])

  if (!transaction.isBooked) {
    return transaction.isBooked
  }

  return (
    <>
      <div className="border-b pb-12 mb-12">
        {costInvoices.length > 0 ? (
          <>
            {costInvoices.map((invoice) => (
              <div key={`invoice${invoice?.id}`}>
                <Attachment
                  title={(invoice.creditNote ? 'Credit Note' : t('costInvoice:costInvoice')) + ' ' + (invoice.invoiceNo ? '#' + invoice.invoiceNo : '')}
                  onClick={() => {
                    setInitialForm(invoice)
                    show(null)
                  }}
                  rightText={
                    invoice.documents && invoice.documents[0]?.createdAtStr && invoice.documents[0]?.createdByStr
                      ? (t('costInvoice:salesInvoiceUploadedBy', {
                        createdAt: dateToStr(new Date(invoice.documents[0]?.createdAtStr)),
                        createdBy: invoice.documents[0]?.createdByStr
                      }))
                      : ''
                  }
                />
              </div>
            ))}
            <span className="d-block mb-12"></span>
          </>
        ) : null}
        <GHref
          onClick={() => {
            setInitialForm(defaultForm)
            show(null)
          }}>
          <FontAwesomeIcon icon={faPlus} className="mr-4" />
          <span className="text-underline">{t('costInvoice:uploadCostInvoice')}</span>
        </GHref>
        {modal}
      </div>
    </>
  )
}

export default React.memo(withPermissionControl(AddCostInvoiceButton, [FINANCE_MODULE_COST_INVOICE]))
